export default __webpack_public_path__ + "static/media/box2_step8.f702d93f.png";